/*
 * Copyright (c) 2025, Ramble Ventures
 */

import { __ } from '@publishpress/i18n';
import {
    useEffect,
    useState
} from "@wordpress/element";
import {
    Button,
    Modal,
    __experimentalVStack as VStack,
    __experimentalHStack as HStack,
} from '@wordpress/components';

import { createRoot } from 'react-dom/client';

const PostRowActions = (props) => {
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [redirectUrl, setRedirectUrl] = useState('');

    useEffect(() => {
        const rowActions = document.querySelectorAll('.ppfuture-run-workflow-from-post-row');

        rowActions.forEach(rowAction => {
            rowAction.addEventListener('click', (e) => {
                const askForConfirmation = rowAction.getAttribute('data-ask-confirmation');
                const confirmationMessage = rowAction.getAttribute('data-confirmation-message');
                const redirectUrl = rowAction.getAttribute('href');

                if (askForConfirmation == '1') {
                    e.preventDefault();

                    setConfirmationMessage(confirmationMessage);
                    setRedirectUrl(redirectUrl);
                    setIsConfirmationModalOpen(true);
                }
            });
        });
    }, []);

    const handleConfirm = () => {
        setIsConfirmationModalOpen(false);

        window.location.href = redirectUrl;
    }

    const handleCancel = () => {
        setIsConfirmationModalOpen(false);
    }

    const handleCloseModal = () => {
        setIsConfirmationModalOpen(false);
    }

    return (
        <>
            {isConfirmationModalOpen && (
                <Modal
                    isOpen={isConfirmationModalOpen}
                    onRequestClose={handleCloseModal}
                    title={__('Confirmation', 'publishpress-future-pro')}
                >
                    <VStack>
                        <p>{confirmationMessage}</p>

                        <HStack>
                            <Button isPrimary onClick={handleConfirm}>
                                {__('Confirm', 'publishpress-future-pro')}
                            </Button>

                            <Button onClick={handleCancel}>
                                {__('Cancel', 'publishpress-future-pro')}
                            </Button>
                        </HStack>
                    </VStack>
                </Modal>
            )}
        </>
    )
};


jQuery(document).ready(function () {
    const wpBody = document.getElementById('wpbody');

    if (wpBody) {
        const newDiv = document.createElement('div');
        newDiv.id = 'ppfuture-post-row-actions';
        wpBody.appendChild(newDiv);
    }

    const container = document.getElementById("ppfuture-post-row-actions");

    if (container) {
        const component = (<PostRowActions />);

        createRoot(container).render(component);
    }
});
